import { CategoryDTOWrapper, CategoryDTO } from '../../shared/DTO/CategoryDTO';

export class Category {
    constructor(
        private id: string,
        private name: string,
        public subCategories: SubCategory[]) { }

    static fromDTOWrapper(categoryDTOWrapper: CategoryDTOWrapper): Category[] {
        const categories: Category[] = [];
        categoryDTOWrapper.moduleCategories.forEach(module => {
            categories.push(this.fromDTO(module));
        });
        return categories;
    }

    static fromDTO(categoryDTO: CategoryDTO): Category {
        const subCategories: SubCategory[] = [];
        categoryDTO.subCategories.forEach(subCategory => subCategories.push(new SubCategory(subCategory, this.formatName(subCategory))));
        return new Category(categoryDTO.category,
                            this.formatName(categoryDTO.category),
                            subCategories);
    }

    private static formatName(name: string): string {
        let words = name.toLowerCase().split('_');
        words = words.map(word => word = word.charAt(0).toUpperCase() + word.slice(1));
        return words.join(' ');
    }

    getId(): string {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    setName(name: string): void {
        this.name = name;
    }
}

export class SubCategory {
    constructor(
        private id: string,
        private name: string) { }

    getId(): string {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    setName(name: string): void {
        this.name = name;
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/categories.model.ts